var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2F59",
    d: "M8 7q0 .405-.281.719l-6 6A1.04 1.04 0 0 1 1 14q-.405 0-.719-.281A1.04 1.04 0 0 1 0 13q0-.405.281-.719L5.594 7 .28 1.719A1.04 1.04 0 0 1 0 1Q0 .595.281.281.594.001 1 0q.405 0 .719.281l6 6q.28.313.281.719"
  })));
};
export default SvgArrowRight;